import { render } from "./onboarding-slider.vue?vue&type=template&id=5533b947"
import script from "./onboarding-slider.vue?vue&type=script&lang=js"
export * from "./onboarding-slider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__